module.exports = __webpack_public_path__ + "static/apple-touch-icon-76x76-300ffa2b7a10e3fb116d85def6c08ad2.png";